/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Upload
 */
export interface Upload {
  /**
   *
   */
  readonly putUrl?: string;
  /**
   *
   */
  filename: string;
  /**
   *
   */
  readonly status?: string;
}

/**
 * Check if a given object implements the Upload interface.
 */
export function instanceOfUpload(value: object): value is Upload {
  if (!("filename" in value) || value["filename"] === undefined) return false;
  return true;
}

export function UploadFromJSON(json: any): Upload {
  return UploadFromJSONTyped(json, false);
}

export function UploadFromJSONTyped(json: any, ignoreDiscriminator: boolean): Upload {
  if (json == null) {
    return json;
  }
  return {
    putUrl: json["put_url"] == null ? undefined : json["put_url"],
    filename: json["filename"],
    status: json["status"] == null ? undefined : json["status"],
  };
}

export function UploadToJSON(json: any): Upload {
  return UploadToJSONTyped(json, false);
}

export function UploadToJSONTyped(
  value?: Omit<Upload, "putUrl" | "status"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    filename: value["filename"],
  };
}
